export default __webpack_public_path__ + "static/media/wrong2-b.a2968181.png";